import { render } from "./AddImagePatient.vue?vue&type=template&id=22407657&ts=true"
import script from "./AddImagePatient.vue?vue&type=script&lang=ts"
export * from "./AddImagePatient.vue?vue&type=script&lang=ts"

import "./AddImagePatient.vue?vue&type=style&index=0&id=22407657&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__